import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils";
import $ from 'jquery'
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"

class StatoVaccinale extends Component {

    state = {
        statoVaccinale: {
            vaccinatoCorrente: "",
            nomeCommerciale: "",
            dataVaccinazione: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.disabledData = this.disabledData.bind(this);
        this.validate = this.validate.bind(this)
    }


    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.statoVaccinale) {
            let statoVaccinale = this.state.statoVaccinale
            let propsVaccinale = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.statoVaccinale))
            statoVaccinale.vaccinatoCorrente = propsVaccinale.vaccinatoCorrente ? propsVaccinale.vaccinatoCorrente : ""
            statoVaccinale.nomeCommerciale = propsVaccinale.nomeCommerciale ? propsVaccinale.nomeCommerciale : ""
            statoVaccinale.dataVaccinazione = propsVaccinale.dataVaccinazione ? propsVaccinale.dataVaccinazione : ""
            this.setState({statoVaccinale: statoVaccinale})
        }
        this.controllaDati()
        this.props.setStatoVaccinale(this.state.statoVaccinale)
        this.disabledData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati()
        if (prevState !== this.state) {
            let res = this.createJsonForBackend()
            this.props.setStatoVaccinale(this.state.statoVaccinale, this.validate(), res)
        }
        this.disabledData()
    }

    validate() {

        if (this.state.statoVaccinale.dataVaccinazione) {
            let validatedataVaccinazione = Utils.checkDateInterval(this.state.statoVaccinale.dataVaccinazione, "31/12/1899");
            let validatedataVaccinazioneOdierna = Utils.checkDateInterval(this.state.statoVaccinale.dataVaccinazione, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataVaccinazione) {
                return "Messages.DataVaccinazione"
            } else if (!validatedataVaccinazioneOdierna) {
                return "Messages.DataVaccinazioneOdierna"
            }
        }

        return ""

    }

    controllaDati() {

        let dati = this.state.statoVaccinale;
        dati.corretto = []

        if(dati.vaccinatoCorrente === "01" ) {
            if (!dati.dataVaccinazione || (Utils.isDateInValid(Utils.transformDateForBackend(dati.dataVaccinazione), "-"))) dati.corretto[0] = "Campo \"Data della vaccinazione\" mancante o errato";
            if (!dati.nomeCommerciale) dati.corretto[1] = "Campo \"Nome commerciale del vaccino\" mancante";
        }

        //
        // if (dati.vaccinatoCorrente === "01" && (Utils.isDateInValid(Utils.transformDateForBackend(dati.dataVaccinazione), "-") || !dati.nomeCommerciale) ||
        //     (dati.dataVaccinazione !== "" && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataVaccinazione), "-"))
        // ) {
        //     dati.corretto = false
        // } else {
        //     dati.corretto = true
        // }
    }

    createJsonForBackend() {

        let dati = this.state.statoVaccinale
        let ObjectForBackEnd = {}
        ObjectForBackEnd["vaccinatoCorrente"] = dati.vaccinatoCorrente
        ObjectForBackEnd["nomeCommerciale"] = dati.nomeCommerciale
        ObjectForBackEnd["dataVaccinazione"] = dati.dataVaccinazione

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;

    }

    disabledData() {

        if (this.state.statoVaccinale.vaccinatoCorrente === "01") {
            $(document).ready(function () {
                $("#dataVaccinazione").datepicker('enable');
            })
        } else {
            $(document).ready(function () {
                $("#dataVaccinazione").datepicker('disable');
            })
        }
    }

    riceviValoreRadioButton(event, field) {
        let statoVaccinale = this.state.statoVaccinale
        statoVaccinale[field] = event
        if (event !== "01") {
            statoVaccinale.nomeCommerciale = ""
            statoVaccinale.dataVaccinazione = ""
        }
        this.setState({statoVaccinale: statoVaccinale})
    }

    riceviValoreInput(field, event) {

        let statoVaccinale = this.state.statoVaccinale
        if (field.currentTarget) {
            statoVaccinale[field.currentTarget.id] = field.currentTarget.value
        } else {
            statoVaccinale[field] = event.target.value
        }
        this.setState({statoVaccinale: statoVaccinale})
    }

    render() {

        const {t} = this.props

        return (<div style={{marginTop: "20px"}}>
            <div>
                <h6>{t("SchedaInfluenzaGrave.statoVaccinale")}</h6>
                <hr className={styles.hr}/>
            </div>
            <div className={"container"}>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.domanda3")}</b></p>

                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton
                                id={"vaccinatoCorrenteSi"}
                                name={"vaccinatoCorrente"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                onClick={() => this.riceviValoreRadioButton("01", "vaccinatoCorrente")}
                                checked={this.state.statoVaccinale.vaccinatoCorrente === "01"}
                            />
                            <RadioButton id={"vaccinatoCorrenteNo"}
                                name={"vaccinatoCorrente"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                onClick={() => this.riceviValoreRadioButton("02", "vaccinatoCorrente")}
                                checked={this.state.statoVaccinale.vaccinatoCorrente === "02"}
                            />
                            <RadioButton id={"vaccinatoCorrenteNonSo"}
                                name={"vaccinatoCorrente"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                onClick={() => this.riceviValoreRadioButton("03", "vaccinatoCorrente")}
                                checked={this.state.statoVaccinale.vaccinatoCorrente === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-5">
                                <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                    <b>{t("SchedaInfluenzaGrave.nomeCommerciale")}</b>{(this.state.statoVaccinale.vaccinatoCorrente === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Input id={"nomeCommerciale"}
                                       field={"nomeCommerciale"}
                                       disabled={this.state.statoVaccinale.vaccinatoCorrente !== "01"}
                                       value={this.state.statoVaccinale.nomeCommerciale}
                                       placeholder={"nomeCommerciale"}
                                       onChange={this.riceviValoreInput}>
                                </Input>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-5">
                                <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                    <b>{t("SchedaInfluenzaGrave.dataVaccinazione")}</b>{(this.state.statoVaccinale.vaccinatoCorrente === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Calendar id={"dataVaccinazione"}
                                          field={"dataVaccinazione"}
                                          value={this.state.statoVaccinale.dataVaccinazione}
                                          onChange={this.riceviValoreInput}
                                          disabled={this.state.statoVaccinale.vaccinatoCorrente !== "01"}
                                          errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                              "Data")}
                                          error={(this.state.statoVaccinale.dataVaccinazione === "" ||
                                              this.state.statoVaccinale.dataVaccinazione == null) ? false :
                                              Utils.isDateInValid(Utils.transformDateForBackend(this.state.statoVaccinale.dataVaccinazione), "-")}
                                >
                                </Calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }


}


export default withTranslation('common')(StatoVaccinale)
